import ApiService from '@/services/api.service'

const MarsAlertService = {

    getMarsAlertByCode(parameter) {              
        const requestData = {
            method: 'get',
            url: "/PatientMarsAlerts",
            headers: {
            },
            params: { 
                Code:parameter.PatientCode,           
                PageSize: parameter.PageSize,          
                PageNumber : parameter.PageNumber,
            }
        }     
        return ApiService.customRequest(requestData);         
    },

    Add(data){
        return ApiService.post(`/PatientMarsAlerts`, data);
    },
    
    Update(Code, data){
        return ApiService.put(`/PatientMarsAlerts/${Code}`,data)
    },
    getMarsAlertListingR(parameter , addExtraParams = false) {  

        const params = {
            Code:parameter.PatientCode,           
            PageSize: parameter.PageSize,          
            PageNumber : parameter.PageNumber,
        };
        
        if (addExtraParams) {
            // Add extra params , only for report listing
            params.PatientCodeList = parameter.PatientCodeList 
            params.PatientIsActive = parameter.PatientIsActive;
            params.ActiveAdmission = parameter.ActiveAdmission;
            params.Code = parameter.Code;
            params.SearchCriteria = parameter.SearchCriteria;
            
            return ApiService.getWithArray('/PatientMarsAlerts/listingR', params); 
        }            
        const requestData = {
            method: 'get',
            url: "/PatientMarsAlerts/listingR",
            headers: {},
            params: params
        }     
        return ApiService.customRequest(requestData);         
    },
}

export default MarsAlertService;